import CommonService from "../../Services/CommonService";

export const FETCH_DEMO_REQUESTS_REQUEST = "FETCH_DEMO_REQUESTS_REQUEST";
export const FETCH_DEMO_REQUESTS_SUCCESS = "FETCH_DEMO_REQUESTS_SUCCESS";
export const FETCH_DEMO_REQUESTS_FAILURE = "FETCH_DEMO_REQUESTS_FAILURE";


export const fetchDemoRequests = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_DEMO_REQUESTS_REQUEST });
    try {
        const response = await CommonService.demoRequestsList(payload);
        dispatch({ type: FETCH_DEMO_REQUESTS_SUCCESS, payload: response.data.data });
    }
    catch (error) {
        dispatch({ type: FETCH_DEMO_REQUESTS_FAILURE, payload: error.message });
    }
};
